import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import moment from 'moment';

import { InputFormModel } from '../models/input-form';
export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MMMM YY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-generate-datapicker-only-year-and-month-input',
  templateUrl: './generate-datapicker-only-year-and-month-input.component.html',
  styleUrls: ['./generate-datapicker-only-year-and-month-input.component.scss'], providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})

export class GenerateDatapickerOnlyYearAndMonthInputComponent implements OnInit {

  @Input() item!: InputFormModel;
  @Input() form!: FormGroup;
  @Input() appearanceForm!: string | undefined;
  appearance: MatFormFieldAppearance = 'fill' as MatFormFieldAppearance;
  selectDate: any;

  constructor() {
    moment.locale('it');
  }

  ngOnInit() {
    this.appearance = this.appearanceForm as MatFormFieldAppearance;
    this.selectDate = moment(this.form.controls[this.item.formControlName].value)
  }

  nextDay() {
    this.selectDate = this.selectDate.add(1, 'month');
    this.form.controls[this.item.formControlName].setValue(this.selectDate)
  }

  previousDay() {
    this.selectDate = this.selectDate.subtract(1, 'month');
    this.form.controls[this.item.formControlName].setValue(this.selectDate)
  }

  toDay() {
    this.selectDate = moment();
    this.form.controls[this.item.formControlName].setValue(this.selectDate)

  }
}
